/* eslint-disable no-undef */
var apiHost =  "https://api.m.jd.com";
function sendRequest(url, data) {
  let xhr;
  if (window.XMLHttpRequest) {
    // 对于支持 XMLHttpRequest 的浏览器，直接创建 XMLHttpRequest 对象
    xhr = new XMLHttpRequest();
    xhr.withCredentials = true; // 允许传递 Cookie
  } else {
    // 对于不支持 XMLHttpRequest 的浏览器，使用 ActiveXObject 创建对应版本的 XHR 对象
    xhr = new ActiveXObject("Microsoft.XMLHTTP");
  }

  // 使用 Promise 包装 XHR 请求
  return new Promise(function (resolve, reject) {
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status == 200) {
          // 解析 JSON 格式的响应数据，并处理请求成功的情况
          try {
            const response = JSON.parse(xhr.responseText);
              resolve(response);
          } catch (error) {
            // 处理响应数据格式错误
            reject(new Error("网络环境异常，请检查后重试哦！如需帮助，请联系京东资产交易客服400-622-9586"));
          }
        } else {
          // 处理请求失败的情况
          reject(new Error("网络环境异常，请检查后重试哦！如需帮助，请联系京东资产交易客服400-622-9586"));
        }
      }
    };

    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xhr.send(JSON.stringify(data));
  });
}

function ajax (functionId, param, appId, securityParams, host) {
  // 调用接口
  const url = new URL(host || apiHost);
  url.pathname = "/api";
  url.searchParams.set("appid", appId);
  url.searchParams.set("functionId", functionId);
  url.searchParams.set("loginType", 3);
  url.searchParams.set("body", JSON.stringify(param))
  if (securityParams) {
    const params2 = {
      clientVersion: securityParams.clientVersion,
      client: securityParams.client,
      t: securityParams.t,
      h5st: securityParams.h5st,
      "x-api-eid-token": securityParams["x-api-eid-token"],
    };

    for (const [key, value] of Object.entries(params2)) {
      url.searchParams.set(key, value);
    }
  }
  let _url = url.toString()
  return sendRequest(_url, null);
}

function colorApi (functionId, param,appId,host) {
  appId = appId || "paimai";

  if (
    !window.PaimaiUtils ||
    !window.PaimaiUtils.Security ||
    !window.PaimaiUtils.Security.getMergedSecurity
  ) {
    console.log('未加载JS')
    return ajax(functionId, param, appId);
  } else {
    const getSecurityParams = {
      appid: appId,
      functionId: functionId,
      body: JSON.stringify(param),
      url: window.location.href,
      isM: true,
    };
    return window.PaimaiUtils.Security.getMergedSecurity(
      getSecurityParams
    ).then(function (data) {
      return ajax(functionId, param, appId, data,host);
    });
  }
}

export default colorApi;
